<template>
  <v-card :class="`px-${paddingPx} py-${paddingPy} elevation-${elevationHeight} ${hardShadow ? 'hard' : ''}`">
    <slot>Content</slot>
  </v-card>
</template>

<script>

export default {
  name: 'finElevatedBox',
  components: {},
  props: {
    elevationHeight: {
      type: Number, default: 4
    },
    paddingPx: {
      type: Number,
      default: 10
    },
    paddingPy: {
      type: Number,
      default: 10
    },
    hardShadow: {
      type: Boolean
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
